<div class="w-full h-full relative">
  <div class="flex flex-row justify-end items-center w-full absolute">
    <sbnb-close [border]="true" (click)="closeModal()"></sbnb-close>
  </div>

  <div id="wizard-content">
    <div class="flex flex-col items-center justify-center gap-2 text-center mb-6">
      <h2 class="m-0">Are you sure you want to turn off dynamic pricing?</h2>
      <p class="mt-0 mb-1 text-night text-sm">
        Your prices will be restored to what they were before you activated it. You can turn it back on anytime.
      </p>
    </div>
    <div class="grid gap-6 grid-cols-[1fr_2fr]">
      <sbnb-button [type]="'secondary'" [fullWidth]="true" [label]="'Cancel'" (click)="closeModal()"></sbnb-button>
      <sbnb-button
        [type]="'primary-error'"
        [fullWidth]="true"
        [loading]="loading"
        [label]="'Yes, turn it off'"
        (click)="turnOffDynamicPricing()"></sbnb-button>
    </div>
  </div>
</div>
